import { RootState } from 'app/store';

export const selectPage =
  (path: string): any =>
  (state: RootState) =>
    state.content[path];

export const selectSiteSettings =
  (locale: string): any =>
  (state: RootState) =>
    state.content[locale]?.PageData?.siteSettings;

export const selectMainMenu =
  (locale: string): any =>
  (state: RootState) =>
    state.content[locale]?.MainMenu;

export const selectCoreSettings = (state: RootState) => {
  const localePath = state?.core?.languagePath;
  return state?.content[localePath!];
}
